import { render, staticRenderFns } from "./EnglishForm.vue?vue&type=template&id=9867f24e&"
import script from "./EnglishForm.vue?vue&type=script&lang=js&"
export * from "./EnglishForm.vue?vue&type=script&lang=js&"
import style0 from "./EnglishForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports